$('#contactAgree').click(function () {
  $('.-need--agree').toggleClass('-agree');
});